module.exports = __webpack_public_path__ + "c02832f9232ece737aa6df0bbb3ed4e4.png";